/* eslint-disable no-invalid-this */

import ApiService, { USERS_API_CONTEXT, USERS_API_HOST } from './ApiService';

/**
 * @override
 */
class GroupsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: USERS_API_HOST });
    }
    /**
     * Get group list
     * @param {Object} sort Sort
     * @param {Object} config Axios config
     * @return {Object} Response with list of groups
     */
    getGroups = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${USERS_API_CONTEXT}/groups?$orderby=${sort}`, config);
        } else {
            return this.getList(`${USERS_API_CONTEXT}/groups`, config);
        }
    };
    /**
     * Get group
     * @param {String} uuid Group UUID
     * @param {Object} config Axios config
     * @return {Object} Response with group
     */
    getGroupsByUUId = (uuid, config) => {
        return this.get(`${USERS_API_CONTEXT}/groups/${uuid}`, config);
    }

    /**
     * Buscar grupos
     * @param {Array} search Búsqueda
     * @param {Object} config Axios config
     * @param {Object} sort Sort
     * @return {Object} Response with users
     */
    getSearch = (search, config, sort = false) => {
        const sortQueryParam = sort ? `&$orderby=${sort}` : '';
        return this.getList(`${USERS_API_CONTEXT}/groups?$search=${search}${sortQueryParam}`, config);
    }

    /**
     * @param {String} url Url
     * @param {Object} config Axios config
     * @return {Object} Response with list of groups
     */
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Actualizamos la información del usuario
     * @param {Object} group Group
     * @return {Object} Response of put operation
     */
    update = group => {
        group.uuid_group = undefined;
        group.uuid_permission_set = undefined;
        group._links._self = undefined;
        group.permission_set = undefined;
        group.group = undefined;
        return this.put(`${USERS_API_CONTEXT}/groups/${group.uuid}`, group);
    };

    /**
     * @override
     */
    download = (sort, config, headers) => {
        if (sort.trim() !== '') {
            return this.getDownload(`${USERS_API_CONTEXT}/groups/download?$orderby=${sort}`, config, { headers });
        } else {
            return this.getDownload(`${USERS_API_CONTEXT}/groups/download`, config, { headers });
        }
    };

    /**
     * Creamos un grupo
     * @param {Object} group Group
     * @return {Object} Response of post operation
     */
    create = group => {
        group.uuid_group = undefined;
        group.uuid_permission_set = undefined;
        group._links._self = undefined;
        group.group = undefined;
        return this.post(`${USERS_API_CONTEXT}/groups`, group);
    };
    /**
     * Delete group
     * @param {String} uuid Group id
     * @return {Object} Response of delete operation
     */
    deleteByUUIId = uuid => {
        return this.delete(`${USERS_API_CONTEXT}/groups/${uuid}`, {});
    };
    /**
     * Change group permission_set
     * @param {String} uuid UUID of group
     * @param {String} permission_set Uri of permission_set
     * @return {Object} Response of patch operation
     */
    changePermissionSet = (uuid, permission_set) => {
        const payload = {
            _links: {
                permission_set
            }
        };
        return this.patch(`${USERS_API_CONTEXT}/groups/${uuid}`, payload);
    };
}

const groupsService = new GroupsService();

export default groupsService;
